var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.44167L8.23333 5.41667H12.9167V8.33333H14.1667V4.16667H8.23333L10.25 2.14167L9.36667 1.25L5.83333 4.79167L9.36667 8.33333L10.25 7.44167ZM10 11.6667C9.50555 11.6667 9.0222 11.8133 8.61107 12.088C8.19995 12.3627 7.87952 12.7531 7.6903 13.21C7.50108 13.6668 7.45157 14.1694 7.54804 14.6544C7.6445 15.1393 7.8826 15.5848 8.23223 15.9344C8.58186 16.2841 9.02732 16.5222 9.51227 16.6186C9.99723 16.7151 10.4999 16.6656 10.9567 16.4764C11.4135 16.2871 11.804 15.9667 12.0787 15.5556C12.3534 15.1445 12.5 14.6611 12.5 14.1667C12.5 13.5036 12.2366 12.8677 11.7678 12.3989C11.2989 11.9301 10.663 11.6667 10 11.6667ZM2.5 9.16667V19.1667H17.5V9.16667H2.5ZM15.8333 15.8333C15.3913 15.8333 14.9674 16.0089 14.6548 16.3215C14.3423 16.634 14.1667 17.058 14.1667 17.5H5.83333C5.83333 17.058 5.65774 16.634 5.34518 16.3215C5.03262 16.0089 4.60869 15.8333 4.16667 15.8333V12.5C4.60869 12.5 5.03262 12.3244 5.34518 12.0118C5.65774 11.6993 5.83333 11.2754 5.83333 10.8333H14.1667C14.1667 11.2754 14.3423 11.6993 14.6548 12.0118C14.9674 12.3244 15.3913 12.5 15.8333 12.5V15.8333Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwpIcon);
export default __webpack_public_path__ + "static/media/swp-icon.9674fc4bf53505a68261d719c46e6de0.svg";
export { ForwardRef as ReactComponent };